import { render, staticRenderFns } from "./welcomesList.vue?vue&type=template&id=534949ca&scoped=true&"
import script from "./welcomesList.vue?vue&type=script&lang=js&"
export * from "./welcomesList.vue?vue&type=script&lang=js&"
import style0 from "./welcomesList.vue?vue&type=style&index=0&id=534949ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534949ca",
  null
  
)

export default component.exports